// src/components/ProjectCard.js
import React from 'react';
import '../styles/ProjectCard.css';

function ProjectCard({ projectName, isNextGen, projectLogo, fundingOrganizations, researchAreas, startDate, endDate, body }) {

  // Function to handle image load errors
  const handleError = (event) => {
    event.target.src = '/default_project.png'; // Fallback image in case the logo fails to load
  };

  return (
    <div className="project-card">
      <div className="project-logo">
        <img src={projectLogo} alt={`${projectName} logo`} onError={handleError} />
      </div>
      <div className="project-info">
        <h2 className="project-name">{projectName}</h2>
        <p><strong>Funder:</strong> {fundingOrganizations.join(', ')}</p>
        <p><strong>Research areas:</strong> {researchAreas.join(', ')}</p>
        <p><strong>Start date:</strong> {new Date(startDate).toLocaleDateString()}</p>
        <p><strong>End date:</strong> {new Date(endDate).toLocaleDateString()}</p>
        <p><strong>Project Details:</strong></p>
        <p>{body}</p>  {/* Displaying the body content */}

        {isNextGen && (
          <div className='project-corporative'>
            <img src={"/images/logos_nextgen_incibe.jpg"} alt={`${"Banda de logos"}`} onError={handleError} />
          </div>
        )}

      </div>
    </div>
  );
}

export default ProjectCard;
